.captchaLayer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 45px);
  background-color: rgb(0 0 0 / 40%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1001;

  & > div {
    padding: 0 16px;
  }
}
